import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexGrow: 1,
    margin: `${spacing.xlarge} ${spacing.small}`,
    justifyContent: 'center',
  },
  content: {
    width: '595px',
  },
  body: {
    '& > * + *': {
      margin: `${spacing.xxxsmall} 0`,
    },
    borderTop: `${spacing.xsmall} solid ${colors.inspectionChecklistReportTopBorder}`,
    padding: `${spacing.medium} ${spacing.xsmall} 0 ${spacing.xsmall}`,
  },
  tableTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: spacing.xlarge,
  },
  table: {
    marginBottom: spacing.small,

    '& > table': {
      tableLayout: 'fixed',
      width: '100%',
    },

    '& > table, th, td': {
      border: `1px solid ${colors.inspectionChecklistReportTableBorder}`,
      borderCollapse: 'collapse',
      boxSizing: 'border-box',
      width: '100%',
      padding: spacing.xxxsmall,
    },

    '& > table tr td': {
      fontWeight: fonts.weights.normal,
      fontSize: fonts.sizes.small,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      wordBreak: 'break-all',
    },

    '& > table tr td:first-child': {
      textAlign: 'center',
      Width: '200px',
      fontWeight: fonts.weights.medium,
      fontSize: fonts.sizes.small,
      lineHeight: '24px',
      letterSpacing: '0.1px',
    },

    '& > table tr td:last-child': {
      paddingLeft: spacing.large,
    },
  },
  answers: {
    paddingLeft: spacing.xxxsmall,
  },
  sectionTitle: {
    padding: `${spacing.xsmall} 0 ${spacing.xsmall} ${spacing.xsmall}`,
    backgroundColor: colors.inspectionChecklistReportSectionBG,
    fontWeight: fonts.weights.normal,
    fontSize: fonts.sizes.medium,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionBody: {
    padding: `${spacing.xsmall} ${spacing.xsmall} 0 ${spacing.xsmall}`,
  },
  question: {
    marginBottom: spacing.xxsmall,
  },
  questionTitle: {
    fontWeight: fonts.weights.normal,
    fontSize: fonts.sizes.medium,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    marginBottom: spacing.small,
  },
  questionReply: {
    fontWeight: fonts.weights.normal,
    fontSize: fonts.sizes.medium,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    marginBottom: spacing.xxxsmall,
  },
  questionNote: {
    fontWeight: fonts.weights.normal,
    fontSize: fonts.sizes.small,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    marginBottom: spacing.small,
  },
  headerTitle: {
    fontWeight: fonts.weights.medium,
    fontSize: fonts.sizes.small,
    lineHeight: '24px',
    letterSpacing: '0.1px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: spacing.large,
    padding: `0 ${spacing.xsmall}`,
    width: '100%',
    backgroundColor: colors.inspectionChecklistReportFooterBG,
  },
  footerText: {
    fontWeight: fonts.weights.medium,
    fontSize: fonts.sizes.small,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  footerTextBold: {
    fontWeight: fonts.weights.bold,
  },
  info: {
    paddingLeft: spacing.xxxsmall,
  },
  infoTitle: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '24px',
  },
  infoValue: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.medium,
    letterSpacing: '0.1px',
    lineHeight: '24px',
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: spacing.xxsmall,
  },
  evidences: {
    width: '100%',

    '& > img': {
      height: '150px',
      objectFit: 'contain',
    },

    '& > video': {
      height: '150px',
      objectFit: 'contain',
    },
  },
});

export default useStyles;
